import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { MatPageable, PageableResponse } from '@core/table/mat-table';
import { PessoaCadastro } from '@core/models/pessoa';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FiltroMudancaSocietaria, MovimentacaoSocietaria, ResultadoMovimentacaoSocietaria } from '@core/models/mudanca-societaria';
import { buildQueryString } from '@shared/util/util';


const baseRef = 'mudanca-entidade';
const route = {
  consultar: `${baseRef}/consultar`,
  // consultarCombo: `${baseRef}/consultar-combo`,
  salvar: `${baseRef}`,
  editar: `${baseRef}`,
  buscarPorid: (id: number) => `${baseRef}/consultar/${id}`,
  buscarPoridEntidade: (id: number) => `${baseRef}/consultarPorEntidade/${id}`,
  // alterarstatus: (id: number,acao:string) => `${baseRef}/alterar-status/${id}/${acao}`,
  // listarPorEntidadeId: (entidadeAdministradoraId: number) => `${baseRef}/entidade/${entidadeAdministradoraId}`,
  // pessoaPaginado: `${baseRef}/consultar-combo-paginado`,
  statusMudancaEntidade: `status-mudanca-entidade/combo`,
  tipoMudancaEntidade: `tipo-mudanca-entidade/combo`,
  tipoEnvolvimento: `tipo-envolvimento`,
  alterarStatus: `${baseRef}/alterar-status`,
  deletarArquivo: (id: number) => `mudanca-documento/${id}`,
  historicoCompanhiasExcel: `${baseRef}/historico-companhias/excel`,
  historicoCompanhiasPdf: `${baseRef}/historico-companhias/pdf`,
}

@Injectable({
  providedIn: 'root'
})
export class MovimentacaoSocietariaService {

  constructor(private apiService: ApiService) { }

  consultar(filtro: FiltroMudancaSocietaria, page: MatPageable) {
    return this.apiService.post<PageableResponse<ResultadoMovimentacaoSocietaria[]>>(`${route.consultar}${page.query}`, this.apiService.removeNullPropertys(filtro));
  }

  consultarSort(filtro: any, page: MatPageable, params: any) {
    const queryString = buildQueryString({ ...params });
    const fullUrl = `${route.consultar}${page.query}${queryString}`;
    return this.apiService.post<PageableResponse<any>>(
      fullUrl,
      this.apiService.removeNullPropertys(filtro)
    );
  }

  cadastrar(obj: MovimentacaoSocietaria) {
    return this.apiService.post<MovimentacaoSocietaria>(route.salvar, obj);
  }

  consultarId(id: number) {
    return this.apiService.get<any>(route.buscarPorid(id));
  }

  // consultarIdDaEntidade(id: number) {
  //   return this.apiService.get<any>(route.buscarPoridEntidade(id));
  // }

  consultarIdDaEntidade(id: number, page: MatPageable) {
    return this.apiService.get<PageableResponse<ResultadoMovimentacaoSocietaria[]>>(`${route.buscarPoridEntidade(id)}${page.query}`);
  }

  consultarSortIdDaEntidade(id: number, page: MatPageable, params: any) {
    const queryString = buildQueryString({ ...params });
    const fullUrl = `${route.buscarPoridEntidade(id)}${page.query}${queryString}`;
    return this.apiService.get<PageableResponse<any>>(
      fullUrl,
      // this.apiService.removeNullPropertys(id)
    );
  }


  statusMudancaEntidade() {
    return this.apiService.get<any[]>(route.statusMudancaEntidade);
  }

  tipoMudancaEntidade() {
    return this.apiService.get<any[]>(route.tipoMudancaEntidade);
  }

  tipoEnvolvimento() {
    return this.apiService.get<any[]>(route.tipoEnvolvimento);
  }

  salvar(obj: MovimentacaoSocietaria) {
    return this.apiService.post<MovimentacaoSocietaria>(route.salvar, obj);
  }

  editar(obj: MovimentacaoSocietaria) {
    return this.apiService.put<MovimentacaoSocietaria>(route.salvar, obj);
  }

  alterarStatus(obj: any) {
    return this.apiService.put<any>(route.alterarStatus, obj);
  }

  deletarArquivo(id: number): Observable<any> {
    return this.apiService.delete<void>(`${route.deletarArquivo(id)}`);
  }

  gerarHistoricoExcel(entidadeIds: number[]) {
    return this.apiService.download(route.historicoCompanhiasExcel, entidadeIds);
  }

  gerarHistoricoPdf(entidadeIds: number[]) {
    return this.apiService.download(route.historicoCompanhiasPdf, entidadeIds);
  }
}
